// extracted by mini-css-extract-plugin
module.exports = {"head":"Home_head__28UWd","filt":"Home_filt__1fADG","container":"Home_container__2-7Ij","pagfoot":"Home_pagfoot__j__Ol"};